export enum PaymentInformationConstants {
  NOT_IMPLEMENTED = 'paymentInformation/NOT_IMPLEMENTED',
  SET_PRIMARY_METHOD_OF_PAYMENT = 'paymentInformation/SET_PRIMARY_METHOD_OF_PAYMENT',
  SET_PRIMARY_METHOD_OF_PAYMENT_PNNV = 'paymentInformation/SET_PRIMARY_METHOD_OF_PAYMENT_PNNV',
  SET_X12_PAYER_TYPE = 'paymentInformation/SET_X12_PAYER_TYPE',
  SET_PRIOR_AUTHORIZATION_PAYER = 'paymentInformation/SET_PRIOR_AUTHORIZATION_PAYER',
  SET_RESPONSE = 'paymentInformation/SET_RESPONSE',
  SAVE_PAYMENT_INFORMATION = 'paymentInformation/SAVE_PAYMENT_INFORMATION',
  SET_PAYMENT_INFORMATION = 'paymentInformation/SET_PAYMENT_INFORMATION',
  RESET_PAYMENT_INFORMATION = 'paymentInformation/RESET_PAYMENT_INFORMATION',
}
